export default __webpack_public_path__ + "static/media/16.db8f1f12.svg";